import { useEffect, useState } from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import TextField from "@mui/material/TextField";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DatePicker from "@mui/lab/DatePicker";
import dayjs from "dayjs";
import { DropDownGeneric } from "../dropdowns";
type InputProps = {
    title?: string;
    checkboxTitle?: string;
    checkboxNotClickable?: boolean;
    placeholder?: string;
    name?: string;
    onChangeFunction?: (arg0: string) => void;
    options?: { name: string }[];
    className?: string;
    inputClassName?: string;
    titleClassname?: string;
    spanClassname?: string;
    editing?: boolean;
    textBoxClass?: string;
    value?: string | number;
    isChecked?: boolean;
    isDisabled?: boolean;
    children?: JSX.Element | false | undefined;
    style?: any;
    yearRange?: { past: number; future: number };
    cutYear?: boolean;
};
function ExpDate({
    checkboxTitle,
    checkboxNotClickable,
    placeholder,
    name = "",
    onChangeFunction,
    options,
    className,
    inputClassName,
    titleClassname,
    editing,
    textBoxClass,
    value = "",
    isChecked = false,
    isDisabled,
    children,
    style,
    spanClassname,
    title = "Exp date",
    yearRange,
    cutYear = false,
}: InputProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [month, setMonth] = useState("");
    const [year, setYear] = useState("");
    const [opt, setYearOpt]: any = useState([]);

    useEffect(() => {
        onChangeFunction?.(month + "/" + year);
    }, [month, year]);

    useEffect(() => {
        if (value) {
            const arr = value.toString().split("/");
            arr[0] && setMonth(arr[0]);
            arr[1] && setYear(arr[1]);
        } else {
            setMonth("");
            setYear("");
        }
    }, [value]);

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const past = yearRange?.past ?? 0;
        const future = yearRange?.future ?? 15;

        const years = [];
        for (let i = currentYear - past; i <= currentYear + future; i++) {
            years.push(cutYear ? i.toString().slice(-2) : i.toString());
        }
        setYearOpt(years);
    }, [yearRange, cutYear]);

    return (
        <div className={`flex  ${className ? className : "flex-col"}`}>
            {title && (
                <div className={`text-r-medium-small-2 ${titleClassname ? titleClassname : ""}`}>
                    <span
                        className={`block overflow-y overflow-x-hidden break-words ${spanClassname}`}
                    >
                        {title}
                    </span>
                </div>
            )}
            <div className="flex flex-row">
                <DropDownGeneric
                    editing={editing}
                    isClearable={false}
                    title=""
                    inputClassName="w-full"
                    className="flex flex-1"
                    name="borrower_authorization"
                    value={month}
                    selectOptions={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
                    placeholder="Month"
                    onChangeFunction={(val) => {
                        setMonth(val);
                    }}
                />
                <div className="flex px-2 justify-center items-center">
                    <span className={`my-auto ${spanClassname}`}>/</span>
                </div>
                <DropDownGeneric
                    editing={editing}
                    className="flex flex-1"
                    title=""
                    isClearable={false}
                    inputClassName="w-full"
                    name="borrower_authorization"
                    value={year}
                    selectOptions={[...opt]}
                    placeholder="Year"
                    onChangeFunction={(val) => {
                        setYear(val);
                    }}
                />
            </div>
        </div>
    );
}

export default ExpDate;
